import { Component, output, input, model, computed, effect, DestroyRef } from '@angular/core';
import { ECalenderNoteType, ICalendarNote } from '../user-calendar.model';
import { UserCalendarService } from '../user-calendar.service';
import { SharedModule } from '../../../../Shared/shared.module';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { configForms, configPatterns, IFormSchema2 } from 'ets-fe-ng-sdk';
import { toSignal } from '@angular/core/rxjs-interop';
import { debounceTime, lastValueFrom, map } from 'rxjs';

@Component({
  selector: 'save-user-calendar-note',
  imports: [SharedModule],
  templateUrl: './save-user-calendar-note.component.html',
  styleUrl: './save-user-calendar-note.component.scss',
})
export class SaveUserCalendarNoteComponent {
  readonly note = model<ICalendarNote>(null);
  readonly date = model<string>(null);

  readonly done = output<ICalendarNote>();
  readonly form = new FormGroup({
    clientNo: new FormControl<string>(null),
    eventOn: new FormControl<string>(new Date().toISOString(),Validators.required),
    eventPlace: new FormControl<string>(null),
    eventType: new FormControl<ECalenderNoteType>(null, Validators.required),
    note: new FormControl<string>(null, Validators.required),
    title: new FormControl<string>(null, Validators.required),
    userName: new FormControl<string>(null),
    id: new FormControl<number>(null),
  });
  readonly formValue = toSignal(this.form.valueChanges.pipe(map(() => this.form.getRawValue())));
  readonly isMeeting = computed(() => this.formValue()?.eventType == ECalenderNoteType.meeting);
  readonly formSchema = computed<IFormSchema2<ICalendarNote>[]>(() => [
    {
      field: 'eventType',
      label: 'Type',
      type: 'select',
      options: this.service.typesForInput(),
      valueField: 'value',
      labelField: 'label',
    },
    { field: 'title', label: 'Title' },
    { field: 'note', label: 'Body', type: 'textarea' },
    { field: 'eventOn', label: 'Time', type: 'datetime-local', min: new Date() as any },
    { field: 'eventPlace', label: 'Meeting Place', hidden: !this.isMeeting(), noFormat: true },
  ]);
  constructor(
    public service: UserCalendarService,
    public dr: DestroyRef,
  ) {
    const typeSub = this.form.controls.eventType.valueChanges.pipe(debounceTime(500)).subscribe((r) => {
      if (r != ECalenderNoteType.meeting) this.form.controls.eventPlace.reset();
    });
    dr.onDestroy(() => {
      typeSub.unsubscribe();
    });
  }

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    if (this.note()) this.form.patchValue(this.note());
  }

  submit = async (val: typeof this.form.value) => {
    const res = await lastValueFrom(this.service.saveCalendarNote({ ...this.note(), ...val }));
    this.done.emit(res);
  };
}
